<template>
  <div class="out">
    <div class="page-title">
      <div class="container">
        <b-jumbotron
          :header="header"
          :lead="leader"
          style="background-color: rgba(0, 0, 0, 0);width:720px"
        />
      </div>
    </div>
    <div class="stickybar">
      <a :style="partI===true ? {'border-bottom': '3px solid #0086f1'} : {'border': 'none'}" @click="jump(1)">业务挑战</a>
      <a :style="partII===true ? {'border-bottom': '3px solid #0086f1'} : {'border': 'none'}" @click="jump(2)">解决方案</a>
      <a :style="partIII===true ? {'border-bottom': '3px solid #0086f1'} : {'border': 'none'}" @click="jump(3)">解决方案优势</a>
      <a :style="partIV===true ? {'border-bottom': '3px solid #0086f1'} : {'border': 'none'}" @click="jump(4)">成功故事</a>
      <!-- <a :style="partV===true ? {'border-bottom': '3px solid #0086f1'} : {'border': 'none'}" @click="jump(5)">相关产品</a> -->
    </div>
    <div
      ref="parti"
      class="review"
      style="background-color: rgba(255, 255, 255); margin-left: 0; margin-right: 0"
    >
      <div class="title">
        <div id="partone" class="top-text contenttext">
          <h3>业务挑战</h3>
        </div>
        <introduceCard :arr="cardarr" style="padding-bottom:90px" />
      </div>
    </div>
    <div
      id="parttwo"
      ref="partii"
      class="review"
      style="background-color: rgba(255, 255, 255); margin-left: 0; margin-right: 0;background:url('https://kingdeecms-1252177366.cos.ap-guangzhou.myqcloud.com/u/cms/www/202009/24161513vl53.png') no-repeat"
    >
      <div class="title">
        <p class="contenttext" style="color:white;text-align:center">
          <br >贸易零售行业数字化转型解决方案
        </p>
        <div class="introducecard-frame">
          <div v-for="(item,index) in arr2" :key="index" :class="{hoverChange:nowindex2 === index}" class="introducecard2" @mouseenter="mouseOver2(index)" @mouseleave="mouseLeave2(index)">
            <div :style="nowindex2===index ? 'overflow:visible;color:white':'overflow:hidden;color:white'" class="introduceText animation">
              <div class="card-title2"><h4>{{ item.title }}</h4></div>
              <div class="card-text2">{{ item.content }}</div>
              <div v-if="nowindex2===index" class="introduceButton2">
                <router-link class="experience-link" to="/aboutUs">详情咨询</router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      id="partthree"
      ref="partiii"
      class="review"
      style="background-color: rgba(128, 126, 126, 0.074); margin-left: 0; margin-right: 0"
    >
      <div class="title">
        <p class="contenttext">
          <br >解决方案优势
        </p>
        <introduceCard3 :arr="cardarr2" style="padding-bottom:90px" />
        <!-- <div class="introducecard-frame">
          <div v-for="(item,index) in arr3" :key="index" class="introducecard2" style="height:364px">
            <div class="image3">
              <img src="https://kingdeecms-1252177366.cos.ap-guangzhou.myqcloud.com/u/cms/www/202010/1118203743vj.png" alt="">
            </div>
            <div :class="{hoverChange2:nowindex3 === index}" class="introduceText3" @mouseenter="mouseOver3(index)" @mouseleave="mouseLeave3(index)">
              <div class="card-title3"><h4>{{ item.title }}</h4></div>
              <div class="card-text3">{{ item.content }}</div>
              <a v-if= "nowindex3 === index">
                <div class="mybtn" >案例详情</div>
              </a>
            </div>
          </div>
        </div> -->
      </div>
    </div>
    <div
      id="partfour"
      ref="partiv"
      class="review"
      style="background: rgba(234,239,243,1); margin-left: 0; margin-right: 0;padding-bottom: 60px;"
    >
      <div class="title">
        <card :arr3="arr3" />
      </div>
    </div>
    <!-- <div
      id="partfive"
      ref="partv"
      class="review"
      style="background-color: rgba(128, 126, 126, 0.074); margin-left: 0; margin-right: 0"
    >
      <div class="title">
        <p class="contenttext">
          <br >相关产品
        </p>
        <div class="introducecard-frame">
          <div v-for="(item,index) in arr" :key="index" :class="{hoverChange:nowindex === index}" class="introducecard" @mouseenter="mouseOver(index)" @mouseleave="mouseLeave(index)">
            <div v-if="nowindex !== index" class="introduceImage">
              <img :src="item.link" alt="">
            </div>
            <div class="introduceText">
              <div class="card-title"><h4>{{ item.title }}</h4></div>
              <div class="card-text">{{ item.content }}</div>
              <div :style="nowindex===index ? {'opacity':1,'marginTop':'40%'} :'opacity:0'" class="introduceButton">
                <a class="experience-link" href="/access">免费体验</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div> -->
  </div>
</template>
<script>
import introduceCard3 from '@/components/introducecard3'
import introduceCard from '@/components/introducecard2'
import Card from '@/components/introducecard'
export default {
  name: 'Trade',
  components: { introduceCard, Card, introduceCard3 },
  data() {
    return {
      header: '贸易零售行业解决方案',
      leader: '提供各环节重塑的数字化解决方案，为传统贸易零售行业企业奠定引领消费升级，重构“人、货、场”关系，构建利益共同体的数字化能力基础',
      cardarr: [
        { title: '传统的流通体系', content: '在传统的流通体系下，品牌商、分销商、零售商需要突出自身专业化，围绕商品向前形成供求一体化关系，支撑大规模制造，大规模销售', link: 'https://kingdeecms-1252177366.cos.ap-guangzhou.myqcloud.com/u/cms/www/202010/15004825jnpm.png' },
        { title: '获客难、成交难、复购难', content: '随着消费主权的崛起，公域流量转向私域流量运营，企业急待精准的客户关系营销，极致的购物体验，通畅的交易闭环，来连接消费者，转化消费者，服务消费者', link: 'https://kingdeecms-1252177366.cos.ap-guangzhou.myqcloud.com/u/cms/www/202010/150049034gox.png' },
        { title: '上下游挤兑，获利空间少', content: '随着互联网去中间化，传统购销获利模式利润空间缩减，需要依赖数字化平台进行商业模式创新，营销通路创新，通过数据共享化，运营精细化，决策敏捷化，提升整体经营服务水平', link: 'https://kingdeecms-1252177366.cos.ap-guangzhou.myqcloud.com/u/cms/www/202010/150049541a3n.png' },
        { title: '吃“大锅饭”，缺乏组织活力', content: '多品类多地域经营模式下，传统科层式管理难以响应市场的快速变化，企业内部需要有效的传递市场压力，通过量化分权手段提升员工的经营意识，激活组织活力', link: 'https://kingdeecms-1252177366.cos.ap-guangzhou.myqcloud.com/u/cms/www/202010/150050456b5q.png' }
      ],
      cardarr2: [
        { title: '平台化架构', content: '以BOS平台、集成平台、流程中心、多语言平台为系统底层架构，低代码，敏捷迭代', link: 'https://kingdeecms-1252177366.cos.ap-guangzhou.myqcloud.com/u/cms/www/202010/15005210nyq1.png' },
        { title: '降本增效，组织激活', content: '供销协同平台，提升企业端到端的数字化高效供应能力，助力企业实现多品类多渠道多组织下的精细化运营管控及管理激活', link: 'https://kingdeecms-1252177366.cos.ap-guangzhou.myqcloud.com/u/cms/www/202010/15005302qy59.png' },
        { title: '连接消费者', content: '支持异业联盟、积分储值、精准营销、互动营销等多种会员营销方式', link: 'https://kingdeecms-1252177366.cos.ap-guangzhou.myqcloud.com/u/cms/www/202010/15005409ot7j.png' },
        { title: '拓展更多营销通道', content: '支撑业务敏捷高效运营，财务前置赋能', link: 'https://kingdeecms-1252177366.cos.ap-guangzhou.myqcloud.com/u/cms/www/202010/15005458np1g.png' }
      ],
      arr: [
        { title: '第一个', content: '为业主/租户开启一站式服务新体验，全面提升服务水平，重塑企业核心竞争力', link: 'https://kingdeecms-1252177366.cos.ap-guangzhou.myqcloud.com/u/cms/www/202010/161909211684.png' },
        { title: '第二个', content: '为业主/租户开启一站式服务新体验，全面提升服务水平，重塑企业核心竞争力', link: 'https://kingdeecms-1252177366.cos.ap-guangzhou.myqcloud.com/u/cms/www/202010/16190843torb.png' },
        { title: '第三个', content: '为业主/租户开启一站式服务新体验，全面提升服务水平，重塑企业核心竞争力', link: 'https://kingdeecms-1252177366.cos.ap-guangzhou.myqcloud.com/u/cms/www/202010/16191004yn4i.png' },
        { title: '第四个', content: '为业主/租户开启一站式服务新体验，全面提升服务水平，重塑企业核心竞争力', link: 'https://kingdeecms-1252177366.cos.ap-guangzhou.myqcloud.com/u/cms/www/202010/16191052buyw.png' }
      ],
      arr2: [
        { title: '快速迭代业务', content: '以BOS平台、集成平台、流程中心、多语言平台为系统底层架构，交付90%配置，10%代码，敏捷迭代，支撑企业应用面对快速变化的市场' },
        { title: '高效供应、精细运营', content: '支持DRP管理、智能要补货、多组织协同、RFID应用，供销协同平台，提升企业端到端的数字化高效供应能力；支持预算、促销、礼券、返利、费用，经营会计，助力企业实现多品类多渠道多组织下的精细化运营管控及管理激活' },
        { title: '全网会员营销体系', content: '会员权益全网统一，会员营销全网触达，会员全生命周期管理，支持异业联盟、积分储值、精准营销、互动营销等多种会员营销方式' },
        { title: '全渠道运营', content: '对多级分销、连锁门店、在线商城、社区团购、直播带货等全渠道交易场景覆盖， 一体化架构，统一商品、统一订单、统一库存、统一会员，支撑业务敏捷高效运营，财务前置赋能' }
      ],
      arr3: [
        { title: '山图酒业：支撑企业全渠道业务拓展与数字化转型', content: '通过数字化快速搭建符合山图酒业国际化、规范化和智能化的多纬度财务评价体系，全面支撑企业全渠道业务拓展与数字化转型，精准投放市场费用，提升流程效率', link: 'https://kingdeecms-1252177366.cos.ap-guangzhou.myqcloud.com/u/cms/www/202010/12105803sa25.png' },
        { title: '机器时代：商业模式创新及数字实践', content: '机器时代连接了超1300家合作商，覆盖了3000余种产品，合作伙伴总估值已超万亿，覆盖过亿消费人群', link: 'https://kingdeecms-1252177366.cos.ap-guangzhou.myqcloud.com/u/cms/www/202010/12105727h9uu.png' }
      ],
      nowindex: '',
      nowindex2: '',
      nowindex3: '',
      nowindex4: 0,
      nowIndex: [0],
      partI: false,
      partII: false,
      partIII: false,
      partIV: false
      // partV: false
    }
  },
  mounted() {
    window.addEventListener('scroll', this.scrollLisenter)
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.scrollLisenter)
  },
  methods: {
    jump: function(x) {
      if (x === 1) {
        x = '#partone'
      }
      if (x === 2) {
        x = '#parttwo'
      }
      if (x === 3) {
        x = '#partthree'
      }
      if (x === 4) {
        x = '#partfour'
      }
      if (x === 5) {
        x = '#partfive'
      }
      document.querySelector(x).scrollIntoView(true)
    },
    scrollLisenter: function() {
      var length = document.documentElement.scrollTop + 37
      if (length >= 0 && length < this.$refs.partii.offsetTop) {
        this.partI = true
      } else this.partI = false
      if (length > this.$refs.partii.offsetTop && length < this.$refs.partiii.offsetTop) {
        this.partII = true
      } else this.partII = false
      if (length > this.$refs.partiii.offsetTop && length < this.$refs.partiv.offsetTop) {
        this.partIII = true
      } else this.partIII = false
      // if (length > this.$refs.partiv.offsetTop && length < this.$refs.partv.offsetTop) {
      //   this.partIV = true
      // } else this.partIV = false
      if (length > this.$refs.partiv.offsetTop) {
        this.partIV = true
      } else this.partIV = false
    },
    mouseOver: function(x) {
      this.nowindex = x
    },
    mouseLeave: function(x) {
      this.nowindex = -1
    },
    mouseOver2: function(x) {
      this.nowindex2 = x
    },
    mouseLeave2: function(x) {
      this.nowindex2 = -1
    },
    mouseOver3: function(x) {
      this.nowindex3 = x
    },
    mouseLeave3: function(x) {
      this.nowindex3 = -1
    },
    mouseOver4: function(x) {
      this.nowindex4 = x
    },
    mouseLeave4: function(x) {
      this.nowindex4 = x
    },

    mouseOvers: function(type, index) {
      this.nowIndex[type] = index
    },
    mouseLeaves: function(type, index) {
      this.nowIndex[type] = 0
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1,
h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}

.out{
  display: inline-block;
  vertical-align:top;
  width:100%;
}

.page-title {
  background: url('https://kingdeecms-1252177366.cos.ap-guangzhou.myqcloud.com/u/cms/www/202010/20171337r2je.jpg') no-repeat;
  background-size: 100% 400px;
  height: 100%;
  text-align: left;
  padding-top: 60px;
  padding-bottom: 2px;
  /* max-width: 1200px; */
  margin: 0 auto;
  position: relative;
  z-index: 1;
}

.title {
  width: 1200px;
  text-align: center;
  margin: 0 auto;
}

.titletext {
  font-size: 50px;
  font-family: "Permanent Marker", cursive;
  color: rgb(22, 21, 21);
}

.contenttext {
  color: rgb(0, 0, 0);
  font-size: 32px;
  /* font-family: Georgia, "Times New Roman", Times, serif; */
  text-align: center;
  padding: 6%;
  padding-top: 4%;
  margin:0;
}

.top-text {
  padding: 50px 0 50px 0;
}

.card {
  display: flex;
  flex-direction: row;
  justify-content: center;
}

.introducecard-frame{
  display: flex;
  flex-wrap: wrap;
  padding-bottom: 50px;
}

.introducecard {
  background-color: rgba(236, 234, 227, 0.39);
  width:293px;
  height:315px;
  display: flex;
  flex-direction: column;
  text-align: center;
  margin: 3px;
  position: relative;
}

.introducecard2 {
  /* background-color: rgba(243, 241, 235, 0.473); */
  /* background-color:rgba(247,247,247,1); */
  background: rgba(35,133,237,0.2);
  height:264px;
  width:584px;
  display: flex;
  flex-direction: column;
  text-align: center;
  position: relative;
  margin:0px 8px 20px 8px;
}

.introduceImage {
  padding-top: 50px;
}

.introduceText {
  padding: 20px 30px 30px 30px;
}

.introduceButton {
  border:1px solid rgba(255,255,255,1);
  background-color: rgba(59, 124, 209, 0.39);
  opacity: 0;
  width:100px;
  margin: auto;
  ;
}

.introduceButton2 {
  border:1px solid rgba(255,255,255,1);
  bottom: 75px;
  background-color: rgba(0, 203, 253, 1);
  width:100px;
  margin: auto;
}

.introduceButton a {
    color:rgba(251,252,253,1);
    font-size:14px;
    text-align: center;
    line-height: 40px;
    text-decoration: none;
}

.introduceButton2 a {
    color:rgba(251,252,253,1);
    font-size:14px;
    text-align: center;
    line-height: 40px;
    text-decoration: none;
}

.hoverChange {
  background-color: rgba(20, 130, 238, 1);
  transition: 0.4s;
  color:white;
  box-shadow: 0px 0px 5px #000;
}

.animation {
  position: relative;
  transition: all 0.4s;
}

.animation:hover {
  transition: transform 0.4s;
  transform: translateY(-40px);
}

.card-title2 {
  margin-top: 10%;
  text-align: left;
}

.card-title3 {
  margin-top: 1%;
  text-align: left;
}

.card-text2 {
  word-break:hyphenate;
  font-size: 14px;
  padding-top: 2%;
  padding-bottom: 2%;
  text-align: left;
  height:120px;
}

.card-text3 {
  font-size: 14px;
  text-align: left;
}

.introduceText3 {
  background-color: rgb(255, 255, 255);
  position: absolute;
  bottom:0;
  transition: all 0.4s;
  height: 140px;
  padding:4%;
}

.introduceText3:hover {
  height: 200px;
  transition:0.4s;
}

.introducecard2 img {
  width:100%;
}

.mybtn {
  width:25%;
  background-color: rgb(62, 88, 112);
  margin: 30px auto;
  padding: 1%;
  color: white;
}

.leftMenu {
  display: flex;
  flex-direction: column;
  width: 150px;
  text-align: left;
  padding: 10% 0%;
  box-shadow: -20px 0px 20px -10px rgb(0 0 0 / 4%) inset;
}

.leftMenu-item {
  padding:18% 10% 18% 10%;
  position: relative;
}

.rightContent {
  width: 100%;
  background-color: rgba(128, 126, 126, 0.075);
  padding:10%;
}

.hoverItem {
  background-color: rgba(45,139,238,1);
  color: ivory;
  width:140%;
  font-size: 20px;
}

.big-title {
  margin: auto;
  padding:5%;
}

.stickybar {
  position: sticky;
  top: 0;
  display: flex;
  background-color: white;
  z-index: 99;
  padding: 0% 7% 0% 13%;
}

.stickybar a{
  padding: 2% 4%;
  cursor: pointer;
  text-decoration: none;
  color: black;
}
</style>



// WEBPACK FOOTER //
// src/views/solutions/components/trade.vue